import { get, post } from '@/utils/http'

// 获取可访问menu
export const menu = () => get('/passport/access/apps/menus')

// 获取可访问menu-租户
export const menusV2 = () => get('/passport/access/apps/menus/v2')

// lambda BFF接口
export const lambdaPassportH5 = (params={}) => get(`${process.env.REACT_APP_LAMBDA}`, params);

// 查询用户关联的数据规则
export const userRoleGet = (params={}) => post(`/passport/user/rule/get`, params)
